<template>
  <div class="login">
    <div class="backgroundImg">
      <!-- <img class="loginPhoto" src="@/assets/photo.png" alt=""> -->
      <img class="login_logo" src="@/assets/login_icon1.png" alt="">
      <div class="login_con">
        <img src="@/assets/login_icon2.png" alt="">
        <span>掌握校园心理健康情况</span>
        <span>测评进度监控、危机预警管理、心理档案自动建档</span>
      </div>
    </div>
    <div class=loginContent>
      <!-- <p>学校端</p> -->
      <div class="remark">
        <p>
          <a href="https://www.lvluoxinli.com/static/html/guide.html" target="_blank"
            style="color:#999999">用户服务指南</a>&nbsp;&nbsp;&nbsp;
          <a href="https://www.lvluoxinli.com/static/html/clause.html" target="_blank"
            style="color:#999999">使用条款和隐私政策</a>&nbsp;&nbsp;&nbsp;
          服务邮箱：lvluoxinli@dingtalk.com
        </p>
        <p>
          ©2020 绿萝心理版权所有&nbsp;&nbsp;&nbsp;
          京ICP备18051758号-2 &nbsp;&nbsp;&nbsp;
          <i class="jgwablogo"></i>
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202008381" target="_blank"
            style="color:#999999">京公网安备11010202008381</a>
        </p>
      </div>
      <div class="ContentFrom">
        <p>绑定成功</p>
        <p>再次扫描登录心理云平台</p>
        <div class="group_4">
          <!-- <div id="wxLogin"></div> -->
          <iframe name="wxIframeQrSucess"
            src='https://open.weixin.qq.com/connect/qrconnect?appid=wx13fce24cf56abac9&self_redirect=true&scope=snsapi_login&href=https://www.lvluoxinli.com/wechat-qr.css&redirect_uri=https://mp.api.lvluoxinli.com/api/user/oplatform/report?cb=https://www.lvluoxinli.com/untitle1d.html'
            frameborder="0" scrolling="no" height="200px"> </iframe>
        </div>

        <div class="image-text_1" @click="back_login">
          <img class="thumbnail_1" referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng40693c010928be0a54b70a06c8898d236210f6890f4557ceb6d4927a6d4d7ad0" />
          <span>返回账号密码登录</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    back_login() {
      sessionStorage.removeItem("wxuserInfo")
      this.$router.push('/')
    }
  }
}
</script>
<style scoped>
p{
  display: block;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}
.login{
  display: flex;
  height: 100%;
  position: relative;
  background: #F8F9FB;
}
.login > p {
  position: absolute;
  bottom: 20px;
  left: 50%;
  color: #999;
  transform: translateX(-50%);position: absolute;
  bottom: 20px;
  left: 50%;
  color: #999;
  transform: translateX(-50%);
}
.login .backgroundImg{
  width: 460px;
  height: auto;
  /* background: url('../../assets/background.png');
  background-size: cover; */
  position: relative;
  background-color: #EAF3CA;
  position: relative;
}
.login .backgroundImg .login_con {
  width: 100%;
  text-align: center;
  position: absolute;
  top: 50%;
  margin-top: -199px;
}
.login .backgroundImg .login_con img {
  width: 300px;
  height: auto;
}
.login .backgroundImg .login_con span {
  display: block;
  color: #19592F;
  font-size: 16px;
}
.login .backgroundImg .login_con > span:nth-child(2) {
  font-size: 24px;
  font-weight: 600;
  line-height: 33px;
  margin: 24px 0px 16px;
  font-family: PingFangSC, PingFang SC;
}

/* .login .backgroundImg .loginPhoto{
  width: 400px;
  height: auto;
  right: 0px;
  bottom: 40px;
  position: absolute;
} */

.loginContent{
  flex: 1;
  height: auto;
  background:#FFFFFF;
  position: relative;
}
.loginContent .remark{
  position: absolute;
  width: 100%;
  bottom: 10px;
  font-size:14px;
  color:rgba(153,153,153,1);
  line-height:14px;
  text-align: center;
}
.loginContent .remark>p{
  padding-bottom: 10px;
}
.loginContent .ContentFrom{
  position: absolute;
  left: 50%;
  top: 50%;
  /* transform:translateY(-50%); */
  transform: translate(-50%, -50%);
  font-family: PingFangSC, PingFang SC;
}
.loginContent>p:first-child{
  font-size:18px;
  font-weight:500;
  color:rgba(153,153,153,1);
  line-height:18px;
  letter-spacing:1px;
  top: 50px;
  right: 60px;
  position: absolute;
  
}
.loginContent .ContentFrom>p:first-child{
  font-size:32px;
  font-weight:600;
  color:#262626;
  line-height: 32px;
  text-align: center;
}
/* .loginContent .ContentFrom>p:nth-child(2){
  font-size:24px;
  font-weight:600;
  color:rgba(0,0,0,1);
  line-height:30px;
  margin-top: 16px;
} */
.loginContent .ContentFrom>p:nth-child(2){
  /* width:222px;
  height:30px;
  font-size:18px;
  font-weight:400;
  color:rgba(0,0,0,1);
  line-height:30px;
  margin-top: 50px; */
  font-size: 14px;
  color: #CD9610;
  line-height: 14px;
  margin-top: 16px;
  text-align: center;
}
.loginContent .ContentFrom .form{
  width: 360px;
}
.loginContent .loginIn{
  text-align: left;
}
.loginContent .loginIn button {
  width:210px;
  height:45px;
}
.loginContent .ant-form {
  width: 75%;
  /* margin: 0 auto; */
}
.login .ant-btn{
  width:210px;
  height:45px;
  background-color: #3c4e6a;
  border-radius:4px;
}
.login .ant-btn-primary{
  background:rgba(36,192,148,1);
  border-color: rgba(36,192,148,1);
  margin-top: 30px;
}
.login .ant-btn-primary:hover {
  color: #FFFFFF;
  background-color: rgba(81, 191, 148, .6);
  border-color: rgba(81, 191, 148, .6);
}
.login .ant-input {
  border: none;
  border-radius:4px;
  /* border-bottom-color: rgba(192,196,204,1); */
  /* border-bottom-style: solid; */
  border-bottom-width: 1px;
  padding: 1px 15px;
  background: #F5F6F8;
  color: #999999;
  width:360px;
  height:45px;
}
.login .ant-input:hover{
  outline: none;
  border-bottom-color:#3c4f6a;
}
.login .ant-input:focus {
    border: none;
    /* border-bottom: 1px solid #3c4f6a !important; */
    box-shadow: none;
}
.login .ant-row.ant-form-item{
  top: 20px;
  margin-bottom: 20px;
}
.login a {
  text-decoration: underline;
}
.jgwablogo{
  width: 16px;
  height: 16px;
  display: inline-block;
  background: url('../../assets/jgwab.png');
  position: relative;
  top: 3px;
}
.login .ant-btn-primary[disabled] {
  color: #FFFFFF;
}
.login .backgroundImg .login_logo {
  width: 140px;
  height: 40px;
  margin: 80px 0px 0px 160px;
}
@media (max-width: 1200px){
  .login .backgroundImg {
    width:420px;
  }
  .login .backgroundImg .login_logo {
    margin: 80px 0px 0px 140px;
  }
  }
@media (max-width: 1060px){
  .login .backgroundImg {
    display: none;
  }
  /* .login {
    width: 900px;
  } */
}
@media (max-height: 600px){
  /* .login {
    height: 600px;
  } */
}
@media (min-width: 569px) {
  .login {
    min-height: 770px;
  }
}

.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.justify-between {
  display: flex;
  justify-content: space-between;
}

.group_4 {
  display: flex;
  flex-direction: row;
  justify-content: center; /* 相对父元素水平居中 */
  /* background-color: rgba(216, 216, 216, 1); */
  /* width: 200px;
  height: 200px; */
   margin: 32px ;
}



.image-text_1 {
  width: 100%;
  color: #595959;
  margin-top: 32px;
  cursor: pointer;
  text-align: center;
  font-size: 14px;
  line-height: 14px;
  font-family: PingFangSC, PingFang SC;
}

.thumbnail_1 {
  width: 16px;
  height: 16px;
  margin-right: 16px;
}

.text-wrapper_2 {
  width: 252px;
  height: 18px;
  margin: 16px 73px;
}

.text_3 {
  width: 252px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(23, 26, 29, 1);
  font-size: 18px;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: right;
  white-space: nowrap;
  line-height: 27px;
}

</style>
